import axios, { CancelTokenSource } from "axios";
import api, { ApiResponse } from "./../api";
import { RelatedEventsLogsFilterModel, RelatedEventsLogsItemModel, RelatedEventsTableInfoModel } from "./relatedEventsLogsModels";

export const REQUEST_ID: {
    [key: string]: string;
} = {
    GET_RECORDS: "get_relatedeventslogs"
};

class RelatedEventsLogsService {
    private source: {
        [key: string]: CancelTokenSource;
    };

    private static instance: RelatedEventsLogsService;

    private constructor() {
        this.source = {};
    };

    static getInstance(): RelatedEventsLogsService {
        if (!RelatedEventsLogsService.instance) {
            RelatedEventsLogsService.instance = new RelatedEventsLogsService();
        }
        return RelatedEventsLogsService.instance;
    };

    public getRelatedEventsLogsRecords = async (
        filter: RelatedEventsLogsFilterModel,
        page: number
    ): Promise<ApiResponse<RelatedEventsLogsItemModel>> => {
        this.source[REQUEST_ID.GET_RECORDS] && this.source[REQUEST_ID.GET_RECORDS].cancel();
        this.source[REQUEST_ID.GET_RECORDS] = axios.CancelToken.source();
            return await api.post("image-history-logs/connectionlinks",
                { ...filter, page },
                {
                    cancelToken: this.source[REQUEST_ID.GET_RECORDS].token,
                }
            );
    };
    public getRelatedEventsTableInfo = async (): Promise<ApiResponse<RelatedEventsTableInfoModel>> => {
        return await api.get("dotnet-programs-logs/tableinfo?type=related");
    };
};

export default RelatedEventsLogsService;
